export function getSpecialties(state) {
  return state.specialties;
}

export function getSpecialtiesList(state) {
  return getSpecialties(state).list.toArray();
}
